import { RefObject, useLayoutEffect, useRef } from 'react';

interface UseScrollAnchorParams {
  anchorRef: RefObject<HTMLElement | null>;
  scrollElement?: HTMLElement | null;
}

interface PendingAnchor {
  top: number;
  scroller: HTMLElement;
}

const useScrollAnchor = ({ anchorRef, scrollElement }: UseScrollAnchorParams) => {
  const pendingAnchorRef = useRef<PendingAnchor | null>(null);

  const captureAnchor = () => {
    const element = anchorRef.current;

    if (!element || !scrollElement) {
      return;
    }

    pendingAnchorRef.current = {
      top: element.getBoundingClientRect().top,
      scroller: scrollElement,
    };
  };

  useLayoutEffect(() => {
    const pendingAnchor = pendingAnchorRef.current;
    const element = anchorRef.current;

    if (!pendingAnchor || !element) {
      return;
    }

    pendingAnchorRef.current = null;

    const delta = element.getBoundingClientRect().top - pendingAnchor.top;

    if (delta !== 0) {
      pendingAnchor.scroller.scrollTop += delta;
    }
  });

  return { captureAnchor };
};

export default useScrollAnchor;
